export const selectionOption = [
  {
    value: 'Atendimento ao assinante',
    label: "Atendimento ao assinante"
  },
  {
    value: 'Comunicar erros',
    label: "Comunicar erros"
  }, 
  {
    value: 'Quero anunciar no impresso',
    label: "Quero anunciar no impresso"
  },
  {
    value: 'Quero anunciar no site',
    label: "Quero anunciar no site"
  },
  {
    value: 'Classificados',
    label: "Classificados"
  },
  {
    value: 'Sugestão de pauta',
    label: "Sugestão de pauta"
  },
  {
    value: 'Fale com a redação',
    label: "Fale com a redação"
  },
  {
    value: 'Trabalhe conosco',
    label: "Trabalhe conosco"
  },
  {
    value: 'Política de privacidade',
    label: "Política de privacidade"
  },
  {
    value: 'Outros',
    label: "Outros"
  }
]